export default "__VITE_ASSET__f69bc331__"